// extracted by mini-css-extract-plugin
module.exports = {"Grid":"ClientOverview_Grid__1l9Xe","Card":"ClientOverview_Card__HSs1M"};